import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

import { Leaves } from '@speeki/frontend-utils';
import { IconManager } from '@speeki/icons';
import { Palette } from '@speeki/theme';

import { getPaletteColor } from '@utils/helpers';

export const AnimatedIcon = styled(IconManager)`
    animation: spin 2s cubic-bezier(0.8, 0, 0.2, 1) infinite;
    transform-origin: 50% 50%;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

const fixedWholeView = css`
    left: 0;
    position: fixed;
    top: 0;
`;

export const LoaderOverlay = styled.div<{
    isFullScreen?: boolean;
    minHeight?: number;
    overlayColor?: Leaves<Palette>;
}>(
    ({ isFullScreen, minHeight, overlayColor, theme: { palette } }) => css`
        ${isFullScreen && fixedWholeView};
        align-items: center;
        background: ${overlayColor
            ? transparentize(
                  0.2,
                  getPaletteColor(palette, overlayColor) as string,
              )
            : 'transparent'};
        display: flex;
        height: 100%;
        justify-content: center;
        min-height: ${minHeight ? minHeight : 300}px;
        width: 100%;
        z-index: 9999;
    `,
);
